import React from "react";

import { Grid } from "@mui/material";

import EndCallButton from "../../Buttons/EndCallButton/EndCallButton";
import SettingsButton from "../../Buttons/SettingsButton/SettingsButton";
import ToggleAudioButton from "../../Buttons/ToggleAudioButton/ToggleAudioButton";
import ToggleCommunication from "../../Buttons/ToggleCommunication/ToggleCommunication";
import ToggleVideoButton from "../../Buttons/ToggleVideoButton/ToggleVideoButton";
import ToggleScreenShareButton from "../../Buttons/ToogleScreenShareButton/ToggleScreenShareButton";
import useStyles from "./styles";

const MenuActions: React.FC<{ toggle: boolean; setToggle: () => void }> = ({
  toggle,
  setToggle,
}) => {
  const classes = useStyles();

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item className={classes.iconsContainer}>
        <ToggleVideoButton />

        <ToggleAudioButton />

        <ToggleScreenShareButton />

        <ToggleCommunication toggle={toggle} setToggle={() => setToggle()} />

        <SettingsButton />
      </Grid>

      <EndCallButton />
    </Grid>
  );
};

export default MenuActions;
